// extracted by mini-css-extract-plugin
module.exports = {"nodata_container":"NoData_nodata_container__260wf","nodata_container_icon":"NoData_nodata_container_icon__AgMgb","nodata_container_text":"NoData_nodata_container_text__2ItYH"};